export const notAvailableStatus = ["confirmation", "package", "delivery"]

export const availableStatusActionGlobal = ["in_transit_for_reception"]

export const availableStatusActionCourier = ["transit"]